import React, { cloneElement, useRef } from 'react';
import {
  TopToolbar,
  CreateButton,
  ExportButton,
  sanitizeListRestProps,
  Button,
} from 'react-admin';

import AddIcon from '@material-ui/icons/Add';

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  enabledCreate,
  handleCriar = () => {},
  ...rest
}) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <Button onClick={handleCriar} label="Novo">
      <AddIcon />
    </Button>
  </TopToolbar>
);

export default ListActions;
